import { z } from "zod";
export const stemLengthSchema = z.enum([
    "6-8 in.",
    "8-12 in.",
    "12-16 in.",
    "16-24 in.",
    "24+ in.",
]);
export const legalStemLengths = stemLengthSchema.options;
export const makeStemLengthRange = (x) => {
    const indices = x.map((e) => legalStemLengths.filter((e) => e !== undefined).indexOf(e));
    if (indices.length === 0)
        return "";
    const xi = Math.min(...indices);
    const yi = Math.max(...indices);
    if (xi === yi)
        return x[0];
    const min = ["6", "8", "12", "16", "24+"][xi];
    const max = ["8", "12", "16", "24", "24+"][yi];
    return `${min} - ${max} in.`;
};
export const bloomSizeSchema = z.enum([
    "<1 in.",
    "1-2 in.",
    "2-3 in.",
    "3-5 in.",
    "5-7 in.",
    "7+ in.",
]);
export const legalBloomSizes = bloomSizeSchema.options;
export const makeBloomSizeRange = (x) => {
    const indices = x.filter((e) => e !== undefined).map((e) => legalBloomSizes.indexOf(e));
    if (indices.length === 0)
        return "";
    const xi = Math.min(...indices);
    const yi = Math.max(...indices);
    if (xi === yi)
        return x[0];
    const min = ["<1", "1", "2", "3", "5", "7+"][xi];
    const max = ["1", "2", "3", "5", "7", "7+"][yi];
    return `${min} - ${max} in`;
};
export const stemsPerBunchSchema = z.union([z.literal(5), z.literal(10)]);
export const legalStemsPerBunch = stemsPerBunchSchema.options.map((option) => option._def.value);
export const vaseLifeSchema = z.enum([
    "0-3 days",
    "3-5 days",
    "5-8 days",
    "8-10 days",
    "10-14 days",
    "14+ days",
]);
export const legalVaseLifes = vaseLifeSchema.options;
export const makeVaseLifeRange = (x) => {
    const indices = x.filter((e) => e !== undefined).map((e) => legalVaseLifes.indexOf(e));
    if (indices.length === 0)
        return "";
    const xi = Math.min(...indices);
    const yi = Math.max(...indices);
    if (xi === yi)
        return x[0];
    const min = ["0", "3", "5", "8", "10", "14+"][xi];
    const max = ["3", "5", "8", "10", "14", "14+"][yi];
    return `${min} - ${max} days`;
};
//# sourceMappingURL=sizes.js.map